import React from 'react';
import * as u from './utils.js'

import AppSettingsContext from './context.js';

import ListLayout from './layouts/list.js';
import GridLayout from './layouts/grid.js';
import SliderLayout from './layouts/slider.js';
import MasonryLayout from './layouts/masonry.js';
import ThumbnailsLayout from './layouts/thumbnails.js';

import SubmitButton from './submit.js';

/*---------------------------------------------*/

export default class TestimonialsSection extends React.Component {
	static contextType = AppSettingsContext;

	render() {
		var sectionBackground = u.renderColor(this.context.get('style.bg.section'));
		let paddingLeftRight = this.context.get('layout.padding.leftright',40,24);
		let paddingTopBottom = this.context.get('layout.padding.topbottom',40,24);
		
		let styles = {
			container: {
				fontSize: 0, // reset spacing
				background: sectionBackground
			},
			title: {
				paddingTop: 40,
				paddingBottom: this.context.get('style.title.paddingBottom',24),
				fontSize: 32,
				textAlign: 'center'
			},
			submit: {
				paddingLeft: paddingLeftRight,
				paddingRight: paddingLeftRight
			},
			promo: {
				paddingTop: (paddingTopBottom < 8) ? (8 - paddingTopBottom) : 0,
				paddingBottom: 16,
				textAlign: 'center',
				fontFamily: 'Helvetica',
				fontSize: 14,
				lineHeight: 1.5
			}
		}

		let layouts = {
			'list': ListLayout,
			'grid': GridLayout,
			'slider': SliderLayout,
			'masonry': MasonryLayout,
			'thumbnails': ThumbnailsLayout
		}

		let layoutType = this.context.get('layout.type');
		let LayoutTag = layouts[layoutType] || ListLayout;
		
		let titleComponent = null;
		if (this.context.get('title.enabled')) {
			let title = this.context.get('title.text') || "Our Testimonials";
			styles.title.color = u.renderColor(this.context.get('style.title.color'));
			
			let fontStyle = u.getFontStyle(this.context,"style.title.font");
			Object.assign(styles.title,fontStyle);

			titleComponent = <div style={styles.title}>{title}</div>;
		}

		let promoComponent = null;
		let plan = window.inffuse.user.plan();
		if (plan === 'free') {
			styles.promo.color = u.renderColor(this.context.get('style.promo.color'));
			promoComponent = <div style={styles.promo}>powered by <b>Praise</b></div>;
		}

		let template = this.context.get('template.id') || 'default';
		if (template.includes('bubble')) {
			let templatePadding = 1*this.context.get('template.padding',40);
			styles.submit.paddingLeft += templatePadding;
			styles.submit.paddingRight += templatePadding;
		}

		let position = this.context.get('form.button.valignment',"top");
		let submitAlignment = this.context.get('form.button.alignment',"center");
		styles.submit.textAlign = submitAlignment;

		let submitComponent = <SubmitButton position={position} baseStyle={styles.submit}></SubmitButton>;
		
		return (
			<div style={styles.container}>
				{titleComponent}
				{(position === 'top') && submitComponent}
				<LayoutTag items={this.props.items} />
				{(position === 'bottom') && submitComponent}
				{promoComponent}
			</div>
		)
	}
}

/*---------------------------------------------*/
